<template>
	<UserRegistrationLayout dontShowInstallationDetails>
		<div class="title-text">Pending installation</div>
		<div class="mt-4 mb-3 title-description-text">You’ve started installing this feature. Want to continue?</div>
		<InstallablePreview class="mb-9 width-100" hidePendingInstall :installableId="installableId" />
		<div class="mt-9"></div>
		<AnemicButton @click="onContinue" class="main-button mt-9"> Continue installation </AnemicButton>

		<div class="display-flex width-100 flex-row flex-align-center my-3 px-5">
			<div class="divider width-100"></div>
			<div class="divider-text mx-2">or</div>
			<div class="divider width-100"></div>
		</div>

		<AnemicButton to="/signup" class="no-button width-100"> Continue without installation </AnemicButton>
	</UserRegistrationLayout>
</template>

<script>
import UserRegistrationLayout from './UserRegistrationLayout.vue';
import UserRegistrationMixin from './helpers/UserRegistrationMixin';
import InstallablePreview from '@/components/Project/InstallablePreview.vue';

export default {
	name: 'PendingInstallationSignup',
	components: {
		InstallablePreview,
		UserRegistrationLayout,
	},
	props: {
		installableId: { type: String },
	},
	mixins: [UserRegistrationMixin],
	computed: {},
	mounted() {},
	methods: {
		onContinue() {
			this.$router.push({
				name: 'InstallationSignup',
				query: this.$route.query,
				params: { installableId: this.installableId },
			});
		},
	},
	data: () => ({}),
};
</script>

<style scoped lang="scss">
.title-text {
	font-size: 22px;
	font-weight: bold;
	color: var(--primary-font-color);
}

.title-description-text {
	font-size: 16px;
	color: var(--primary-font-color);
}
.main-button {
	padding: 0px;
	width: 300px;
	height: 45px;
	background: var(--bold-border-color) !important;
	color: var(--bg-color);
	font-size: 14px !important;
}
.no-button {
	height: 45px;
	width: 300px;
	padding: 0px;
	font-size: 14px !important;
	color: var(--bold-border-color);
	background: var(--bg-color) !important;
	border: 1px solid var(--bold-border-color);
}
.divider-text {
	font-size: 14px;
	color: #babdc4;
}
.divider {
	height: 1px;
	margin-top: 2px;
	background: #babdc4;
}
.dismiss-installation-text {
	font-size: 14px;
	cursor: pointer;
	text-decoration: underline;
	color: var(--bold-border-color);
}
</style>
